import { Component, Vue } from 'vue-property-decorator'
import { getAnomalyList } from '@/api'
import HighFilter from '@/components/highFilter/index.vue'
@Component({ name: 'AbnormalApproveListPage', components: { HighFilter } })
export default class AbnormalApproveListPage extends Vue {
  private totalPage = 1;
  private totalNum = 1;
  private currentPage = 1;
  private filterTypeChoose = null;
  private showHighFilter = false
  private filterData: any = {}
  private filterResult: any = null
  private tableloading = false
  created () {
    this.initPageData()
  }

  private async initPageData () {
    this.tableloading = true
    const param: any = { page: this.currentPage, limit: 20 }
    if (this.filterResult) {
      param.search = this.filterResult
    }
    const result: any = await getAnomalyList(param)
    const { allPage, currentPage, workOrderList, allNumber } = result
    this.filterData = result.search
    this.currentPage = currentPage
    this.totalPage = allPage
    this.tableData = workOrderList
    this.totalNum = allNumber
    this.tableloading = false
  }

  private tableData = []

  private booleanFilter (row: any, column: any, cellValue: any, index: any) {
    return cellValue === 1 ? '是' : '否'
  }

  //
  private onApproveClick (item: any) {
    this.$router.push({ path: '/approve/anomaly', query: { id: item.id, action: 'look' } })
  }

  /**
   * [description] 创建异常
   */
  private onCreateClick () {
    this.$router.push({ path: '/create_abnormal' })
  }

  private onPageChange () {
    this.initPageData()
  }

  private async onFilterResult (data: any) {
    this.filterResult = data
    this.currentPage = 1
    await this.initPageData()
    this.showHighFilter = false
  }
}
